import * as pdfjsLib from 'pdfjs-dist/webpack.mjs'
import { dateConversion } from '../../../../../../utils/rolecreationHelpers'
export const autoJDFillStepNum = 0
export const jobDetailsStepNum = 1
export const ctcOrStipendStepNum = 2
export const eligibilityCriteriaStepNum = 3
export const previewStepNum = 4
export const payloadDataFormatForQualification1 = data => {
  return data?.map(item => {
    const result = []
    Object.keys(item)?.forEach(degreeType => {
      const degreeData = item[degreeType]
      if (degreeData?.isAllDegree) {
        result?.push({
          degreeType,
          isAllDegree: true,
        })
      } else {
        degreeData?.data?.forEach(degree => {
          degree?.streams?.forEach(stream => {
            const specialisationIds = stream?.specialisations?.map(
              spec => spec.specialisationId
            )
            result?.push({
              degreeId: degree.degreeId,
              streamId: stream.streamId,
              degreeType: degree?.type,
              specialisationId: specialisationIds,
            })
          })
        })
      }
    })

    return result
  })
}

// Function to check if two arrays are identical
// const areArraysEqual = (arr1, arr2) => {
//   return arr1?.every((element, index) => element === arr2[index])
// }

const hasCommonElement = (arr1, arr2) => {
  return arr1?.some(element => arr2?.includes(element))
}

// Function to check if an object with the same degreeId, streamId, and specialisationId already exists
const isDuplicate = (arr, newObj) => {
  return arr?.some(
    item =>
      item.degreeId === newObj.degreeId &&
      item.streamId === newObj.streamId &&
      hasCommonElement(item?.specialisationId, newObj?.specialisationId)
  )
}

// Function to remove duplicates after adding new items

const removeDuplicates = arr => {
  if (!Array.isArray(arr)) return [] // Check if input is an array

  return arr?.reduce((acc, current) => {
    if (current?.isAllDegree) {
      acc.push(current)
      return acc
    }

    const existingIndex = acc.findIndex(
      item =>
        item?.degreeId === current?.degreeId &&
        item?.streamId === current?.streamId
    )

    if (existingIndex !== -1) {
      // If there's an existing object with the same degreeId and streamId,
      // remove the overlapping specialisationId values
      const existingItem = acc[existingIndex]

      // Ensure specialisationId is an array before filtering
      const filteredSpecialisationId =
        Array.isArray(current?.specialisationId) &&
        Array.isArray(existingItem?.specialisationId)
          ? current.specialisationId.filter(
              id => !existingItem.specialisationId.includes(id)
            )
          : []

      // If there are remaining specialisationIds after filtering, add to the result
      if (filteredSpecialisationId?.length > 0) {
        acc[existingIndex].specialisationId = [
          ...(existingItem.specialisationId || []),
          ...filteredSpecialisationId,
        ]
      }
    } else {
      // If there's no existing object, add the current object as is
      acc.push(current)
    }

    return acc
  }, [])
}

const removeEmptyObjects = arr => {
  return arr?.filter(item => {
    const hasValidValues =
      Object.keys(item)?.length > 0 &&
      (item?.degreeId !== undefined || item?.degreeType !== undefined)
    return hasValidValues
  })
}

export const payloadDataFormatForQualification = data => {
  return data
    ?.map(item => {
      let result = []

      Object?.keys(item)?.forEach(degreeType => {
        const degreeData = item[degreeType]

        if (degreeData.isAllDegree) {
          result?.push({
            degreeType,
            isAllDegree: true,
          })
        } else if (degreeData?.data?.length > 0) {
          degreeData.data?.forEach(degree => {
            if (degree?.streams && degree?.streams?.length > 0) {
              degree?.streams?.forEach(stream => {
                const specialisationIds = stream?.specialisations?.map(
                  spec => spec?.specialisationId
                )
                if (
                  !isDuplicate(result, {
                    degreeId: degree?.degreeId,
                    streamId: stream?.streamId,
                    specialisationId: specialisationIds,
                  })
                ) {
                  result.push({
                    degreeId: degree?.degreeId,
                    streamId: stream?.streamId,
                    degreeType: degree?.type,
                    specialisationId: specialisationIds,
                  })
                }

                result = removeDuplicates(result)
              })
            } else {
              result?.push({
                degreeType: degree?.type,
                degreeId: degree.degreeId,
              })
            }
          })
        }
      })
      return result?.length > 0 ? removeEmptyObjects(result) : null
    })
    ?.filter(Boolean)
}

export const payloadDataFormatForPreviewData = data => {
  let finalArray = []

  data?.forEach(item => {
    if (item?.selected && typeof item.selected === 'object') {
      const fixedSelected = {}

      // Ensure each selected value is an array
      for (const key in item.selected) {
        if (Array.isArray(item.selected[key])) {
          fixedSelected[key] = item.selected[key]
        } else {
          if (
            item.selected[key]?.data?.length &&
            !item.selected[key]?.isAllDegree
          ) {
            item.selected[key]?.data?.forEach(degree => {
              degree.name = degree?.degreeName || degree?.degreeShortForm
              degree.shortForm = degree?.shortForm || degree?.degreeShortForm
              degree.degreeType = degree?.type
              degree.isDegreeOnly = degree?.streams?.length ? false : true
              ;(degree.id = degree?.degreeId),
                (degree.streams = degree?.streams?.map(stream => {
                  return {
                    ...stream,
                    id: stream?.streamId,
                    name: stream?.streamName,
                    specialisations: stream?.specialisations?.map(spec => {
                      return {
                        ...spec,
                        id: spec?.specialisationId || spec?.id,
                        name: spec?.name || spec?.specialisationName,
                      }
                    }),
                  }
                }))
            })

            fixedSelected[key] = item?.selected[key]?.data
          } else if (item?.selected[key]?.isAllDegree) {
            fixedSelected[key] = [
              { isAllDegree: item?.selected[key]?.isAllDegree },
            ]
          }
        }
      }
      finalArray.push({
        qualification: item?.type || [],
        selected: fixedSelected,
      })
    }
  })
  const filteredArray = finalArray?.filter(
    item => item?.qualification?.length > 0
  )
  return filteredArray
}

export const formattingDataFromPayloadToQualification = (
  criteria,
  currentCourse
) => {
  const selected = {
    UG: { isAllDegree: false, data: [] },
    PG: { isAllDegree: false, data: [] },
    DIPLOMA: { isAllDegree: false, data: [] },
  }

  const defaultStructure = [
    {
      type: [],
      allSelect: false,
      search: '',
      data: [],
      toSearch: 'ALL',
      selected: {
        ...selected,
      },
      totalTypes: [],
    },
  ]
  const totalTypes = criteria?.map(item => item?.qualification)?.flat()

  if (!criteria || criteria?.length === 0) {
    return defaultStructure
  }
  return criteria?.map(item => {
    const type = item?.qualification
    const selected = item?.selected

    const transformedSelected = {
      UG: {
        isAllDegree: false,
        data: [],
      },
      PG: {
        isAllDegree: false,
        data: [],
      },
      DIPLOMA: {
        isAllDegree: false,
        data: [],
      },
    }

    Object.keys(selected)?.forEach(degreeType => {
      const degreeData = selected?.[degreeType]

      if (degreeData?.length > 0 && !degreeData?.[0]?.isAllDegree) {
        degreeData?.forEach(degree => {
          // Initialize transformedSelected structure if it doesn't exist
          if (!transformedSelected?.[degreeType]) {
            transformedSelected[degreeType] = {
              data: [],
              isAllDegree: false,
            }
          }

          // Check if the degree already exists in transformedSelected
          let existingDegree = transformedSelected[degreeType].data.find(
            item => item.degreeId === degree?.id
          )

          if (!existingDegree) {
            // Add a new degree object if it doesn't exist
            existingDegree = {
              degreeId: degree?.id,
              type: degree?.type,
              degreeShortForm: degree?.degreeShortForm || degree?.shortForm || degree?.name, // Assuming 'M.Tech' is the short form
              isSelected: true,
              shortForm: degree?.shortForm,
              streams: [],
            }
            transformedSelected[degreeType].data.push(existingDegree)
          }

          // Transform streams and merge them into the existing degree
          const transformedStreams = degree.streams?.map(stream => ({
            streamId: stream?.id,
            streamName: stream?.name,
            isSelected: true,
            specialisations: stream?.specialisations?.map(spec => ({
              specialisationName: spec?.name,
              specialisationId: spec?.id,
              specialisationStatus: 1,
              streamSpecialisationId: spec?.id, // Assuming streamSpecialisationId is same as spec.id
              isSelected: true,
            })),
          }))

          // Merge streams (avoid duplicates)
          transformedStreams?.forEach(stream => {
            const existingStream = existingDegree.streams.find(
              s => s.streamId === stream.streamId
            )
            if (!existingStream) {
              existingDegree.streams.push(stream)
            }
          })
        })
      } else if (transformedSelected[degreeType]) {
        // If no degree data, set isAllDegree flag
        transformedSelected[degreeType].isAllDegree = true
      }
    })

    return {
      type: type,
      allSelect: false,
      search: '',
      data: [],
      toSearch: 'ALL',
      selected: transformedSelected,
      totalTypes: totalTypes,
    }
  })
}
export const isEligibilityCriteriaEqual = (
  previewEligibilityCriteria,
  initialResponseEligibilityCriteria
) => {
  const preview = previewEligibilityCriteria
  const initial = initialResponseEligibilityCriteria

  // Step 1: Check array length
  if (preview?.length !== initial?.length) {
    return false
  }

  // Step 2 & 3: Loop through each item and compare
  for (let i = 0; i < preview?.length; i++) {
    const previewItem = preview?.[i]
    const initialItem = initial?.[i]

    const previewQual = previewItem?.qualification || []
    const initialQual = initialItem?.qualification || []

    // Step 2: Check qualification length
    if (previewQual.length !== initialQual.length) {
      return false
    }

    // Step 3 & 4: Check selected lengths and degreeId equality
    for (const qualificationType of previewQual) {
      const previewSelected = previewItem?.selected?.[qualificationType] || []
      const initialSelected = initialItem?.selected?.[qualificationType] || []

      const previewHasAll = previewSelected?.some(
        item => item?.isAllDegree === true
      )
      const initialHasAll = initialSelected?.some(
        item => item?.isAllDegree === true
      )

      if (previewHasAll) {
        if (initialHasAll) {
          continue
        } else {
          return false
        }
      }

      const getValidUniqueSortedIds = arr => {
        return [
          ...new Set(
            (arr || [])
              .map(d => d?.degreeId || d?.id)
              .filter(id => typeof id === 'string' && id.trim() !== '')
          ),
        ].sort()
      }

      const previewDegreeIds = getValidUniqueSortedIds(previewSelected)
      const initialDegreeIds = getValidUniqueSortedIds(initialSelected)

      const idsMatch =
        previewDegreeIds?.length === initialDegreeIds?.length &&
        previewDegreeIds.every((id, index) => id === initialDegreeIds[index])

      // Step 4: Compare streamIds
      const previewStreamIds = previewSelected
        .flatMap(d => d?.streams?.map(s => s.id))
        ?.sort()
      const initialStreamIds = initialSelected
        .flatMap(d => d?.streams?.map(s => s.id))
        ?.sort()
      const streamIdsMatch =
        previewStreamIds?.length === initialStreamIds?.length &&
        previewStreamIds.every((id, index) => id === initialStreamIds[index])

      if (!idsMatch || !streamIdsMatch) {
        return false
      }
    }
  }

  return true
}

export const hasChanged = data => {
  let fileData = data?.jobRoleDocs?.map(
    ({ fileName, fileType, fileUrl, fileSize }, index) => {
      return {
        fileName: fileName,

        fileType: fileType,
        fileUrl: fileUrl,
        fileSize: fileSize,
      }
    }
  )
  return {
    interviewWorkFlow: data?.interviewWorkFlow,
    jobDetails: {
      tittle: data?.tittle,
      function: data?.function,
      functionId: data?.functionId,
      jobTypeLevels: data?.jobTypeLevels,
      yearOfExperience: data?.yearOfExperience,
      jobType: data?.jobType,
      employmentType: data?.employmentType,
      jobCategory: data?.jobCategory,
      jobDependency: data?.jobDependency,
      description: data?.description,
      minVacancies: data?.minVacancies,
      maxVacancies: data?.maxVacancies,
      startDate: dateConversion({
        date: data?.startDate,
        convertTo: 'YYYY-MM-DD',
      }),
      endDate: data?.endDate,
      publishTo: 'ALL',
      internshipStartDate: data.internshipStartDate,
      internshipEndDate: data.internshipEndDate,
      workStyle: data?.workStyle,
      externalLink: data?.externalLink,
      companyId: data?.companyId,
      jobRoleDocs: data?.jobRoleDocs?.length > 0 ? fileData : [],
      internshipDuration: data?.internshipDuration ?? null,
      gigsDuration: data?.gigsDuration ? data?.gigsDuration : [0],
    },
    companyDetails: {
      companyName: data?.company?.companyName,
      website: data?.company?.website,
      otherLinks: data?.company?.otherLinks,
      description: data?.company?.description,
    },
    ctc: {
      isTierBased: data?.CTCIsTierBased,
      isBond: data?.isBond,
      bondType: data?.bondType,
      additionalBenefits: data?.additionalBenefits,
      stipend: data?.stipend,
      tiers: [
        {
          name: data?.CTC?.[0]?.name,
          currency: 'INR',
          min: data?.CTC?.[0]?.min,
          max: data?.CTC?.[0]?.max,
          isRange: data?.CTC?.[0]?.isRange,
        },
      ],
      period: data?.CTCPeriod,
    },
    jobLocation: {
      cities: data?.cities,
      isAnyWhere: data?.isAnyWhere,
    },
    elgibilty: {
      roleFlotedTo: data?.roleFlotedTo?.map(item => item.id),
      degreeStreamMapIds: data?.degreeStreamMapIds,
      isArrearsAllowed: data?.isArrearsAllowed,
      arrearCount: {
        condition: data?.arrearCondition,
        count: data?.arrearCount,
      },
      eligibilityCriteria: [],
      mandatorySkills: {
        primary: {
          type: data?.mandatorySkills?.primary?.type,
          skills: data?.mandatorySkills?.primary?.skills,
        },
        mandatory: data?.mandatorySkills?.mandatory,
        otherSkills: data?.mandatorySkills?.otherSkills,
        mandatoryCount: data?.mandatorySkills?.mandatoryCount,
      },
      optionalSkills: data?.optionalSkills,
      yearOfPassing: data?.yearOfPassing,
      scores: {},
    },
    status: data?.status,
  }
}

export const convertEligibilityData = arr => {
  if (!arr || arr.length === 0) {
    return []
  }
  return arr?.map(subArray =>
    subArray?.map(({ degreeStreamMapId, isDegreeOnly, ...rest }) => {
      const { degreeId, degreeType, streamId, ...data } = rest
      return {
        degreeId,
        streamId,
        degreeType: degreeType == 'PG_DIPLOMA' ? 'P_G_DIPLOMA' : degreeType,
        ...data,
      }
    })
  )
}

export const isJobDetailsFilled = (jobDetails, gigStatus, experienceStatus) => {
  console.log('isJobDetailsFilled called with:', { jobDetails, gigStatus, experienceStatus });
  const {
    companyName,
    endDate,
    startDate,
    description,
    jobCategory,
    jobType,
    workStyle,
    internshipDuration,
    jobTypeLevels,
  } = jobDetails

  const isFieldFilled = field =>
    field !== undefined && field !== null && field !== ''

  const basicFieldsFilled =
    isFieldFilled(companyName) &&
    isFieldFilled(endDate) &&
    isFieldFilled(startDate) &&
    isFieldFilled(description) &&
    isFieldFilled(jobCategory) &&
    isFieldFilled(jobType) &&
    isFieldFilled(workStyle)

  const internshipFieldsFilled =
    jobCategory !== 'INTERNSHIP' || isFieldFilled(internshipDuration)
  const gigsFieldsFilled = jobCategory !== 'GIGS' || gigStatus === false
  const experienceFieldsFilled =
    (jobTypeLevels != 'BOTH' || jobTypeLevels != 'EXPERIENCED') &&
    !experienceStatus
  const result = (
    basicFieldsFilled &&
    internshipFieldsFilled &&
    gigsFieldsFilled &&
    experienceFieldsFilled
  )
  console.log('Job details validation result:', { 
    basicFieldsFilled, 
    internshipFieldsFilled, 
    gigsFieldsFilled, 
    experienceFieldsFilled, 
    result 
  });
  return result
}

export const isCTCAndLocationFilled = (
  ctc,
  jobLocation,
  jobCategory,
  workStyle
) => {
  console.log('isCTCAndLocationFilled called with:', { ctc, jobLocation, jobCategory, workStyle });
  const {
    period,
    min,
    isNoStipend,
    additionalBenefits,
    isAdditional,
    isBond,
    isRange,
    max,
    bondType,
  } = ctc
  const { isRemoteAllowed, isAnyWhere, cities } = jobLocation

  const isFieldFilled = field =>
    field !== undefined && field !== null && field !== ''
  const isArrayFilled = array => array && array.length > 0

  let ctcFilled = false
  let locationFilled = false
  switch (jobCategory) {
    case 'INTERNSHIP':
    case 'APPRENTICESHIP':
      ctcFilled =
        isFieldFilled(period) &&
        (isNoStipend ? isFieldFilled(min) : true) &&
        (isAdditional ? isFieldFilled(additionalBenefits) : true)
      locationFilled =
        workStyle != 'REMOTE'
          ? isFieldFilled(isAnyWhere) &&
            (!isAnyWhere ? isArrayFilled(cities) : true)
          : true

      break
    case 'PLACEMENT':
    case 'GIGS':
      ctcFilled =
        isFieldFilled(period) &&
        isFieldFilled(min) &&
        (isRange ? isFieldFilled(max) : true) &&
        (isBond ? isFieldFilled(bondType) : true) &&
        (isAdditional
          ? isFieldFilled(additionalBenefits) &&
            additionalBenefits !== '<p><br></p>'
          : true)
      locationFilled =
        workStyle != 'REMOTE'
          ? isFieldFilled(isAnyWhere) &&
            (!isAnyWhere ? isArrayFilled(cities) : true)
          : true
      break
    default:
      ctcFilled = isFieldFilled(period) && isFieldFilled(min)
      locationFilled =
        isFieldFilled(isRemoteAllowed) && isFieldFilled(isAnyWhere)
      break
  }

  console.log('CTC validation result:', { ctcFilled, locationFilled, result: ctcFilled && locationFilled });
  return ctcFilled && locationFilled
}

export const isQualityCriteriaValid = (qualityCriteria, yearOfPassing) => {
  console.log('isQualityCriteriaValid called with:', { qualityCriteria, yearOfPassing });
  const isArrayFilled = array => array && array.length > 0

  const qualityCriteriaValid = qualityCriteria.some(criteria => {
    const { selected } = criteria

    // Check if any of the selected types have isAllDegree set to true or data length greater than 0
    for (const key in selected) {
      if (
        selected[key].isAllDegree ||
        (selected[key].data && selected[key].data.length > 0)
      ) {
        return true
      }
    }

    return false
  })

  // Check yearOfPassing
  const yearOfPassingValid = isArrayFilled(yearOfPassing)

  const result = qualityCriteriaValid && yearOfPassingValid
  console.log('Quality criteria validation result:', { 
    qualityCriteriaValid, 
    yearOfPassingValid, 
    result 
  });
  return result
}
export const checkValidationCopy = (
  roleFormData,
  currentStep,
  fieldName,
  fieldNameValue,
  firstYear,
  firstMonth,
  secondYear,
  secondMonth,
  errSet,
  statusField,
  errId,
  fillMessage,
  invalidMessage
) => {
  if (
    roleFormData?.jobDetails[fieldName] &&
    roleFormData?.jobDetails[fieldName] == fieldNameValue &&
    currentStep === jobDetailsStepNum
  ) {
    const firstTotalMonths =
      Number(roleFormData?.jobDetails?.[firstYear]) * 12 +
      Number(roleFormData?.jobDetails?.[firstMonth])
    const secondTotalMonths =
      Number(roleFormData?.jobDetails?.[secondYear]) * 12 +
      Number(roleFormData?.jobDetails?.[secondMonth])
    if (secondTotalMonths) {
      if (firstTotalMonths > secondTotalMonths) {
        errSet(`${invalidMessage}`)
        statusField = true
      } else {
        statusField = false
        errSet('')
      }
    }
  } else {
    statusField = false
    errSet('')
  }
  return statusField
}

export const handlePdfFile = async file => {
  try {
    const pdf = await pdfjsLib.getDocument({ url: URL.createObjectURL(file) })
      .promise
    const numPages = pdf.numPages
    const images = []

    for (let pageNum = 1; pageNum <= numPages; pageNum++) {
      const page = await pdf.getPage(pageNum)
      const viewport = page.getViewport({ scale: 1.5 })
      const canvas = document.createElement('canvas')
      const context = canvas.getContext('2d')
      canvas.height = viewport.height
      canvas.width = viewport.width
      const renderContext = {
        canvasContext: context,
        viewport: viewport,
      }
      await page.render(renderContext).promise
      images.push(canvas.toDataURL())
    }

    // setPdfImages(images)
    return images
  } catch (error) {
    console.error('Error rendering PDF:', error)
  }
}

export const getFileSize = fileSize => {
  if (fileSize < 1024) {
    // If the size is less than 1 KB, show it in bytes
    return `${fileSize} B`
  } else if (fileSize < 1024 * 1024) {
    // If the size is less than 1 MB, show it in kilobytes
    return `${(fileSize / 1024).toFixed(2)} KB`
  } else {
    // Otherwise, show it in megabytes
    return `${(fileSize / 1024 / 1024).toFixed(2)} MB`
  }
}

export const getCoursesLabel = item =>
  ({
    UG: 'UG',
    PG: 'PG',
    DIPLOMA: 'Diploma',
    P_G_DIPLOMA: 'PG Diploma',
    PHD: 'PHD',
  }[item] || item)

export const universalEduArr = (data, i) =>
  i === 0 && data
    ? data.map((item, index) => ({
        id: index + 1,
        label: getCoursesLabel(item),
        value: item,
      }))
    : [
        { id: 1, label: 'UG', value: 'UG' },
        { id: 2, label: 'PG', value: 'PG' },
        { id: 3, label: 'Diploma', value: 'DIPLOMA' },
      ]

export const flatMapFunction = data => {
  if (Array.isArray(data)) {
    return data.flatMap(
      ({ degreeShortForm, streams, type, degreeId }, degreeIndex) => {
        if (Array.isArray(streams) && streams.length > 0) {
          return streams.flatMap(
            ({ streamName, specialisations, streamId }, streamIndex) => {
              if (
                Array.isArray(specialisations) &&
                specialisations.length > 0
              ) {
                return specialisations.flatMap(
                  ({ specialisationName, specialisationId }, specIndex) => {
                    return {
                      label: `${degreeShortForm} - ${streamName} - ${specialisationName}`,
                      indices: {
                        degreeIndex,
                        streamIndex,
                        specIndex,
                        field: 'specialisation',
                        degreeId,
                        streamId,
                        specialisationId,
                        type,
                      },
                    }
                  }
                )
              } else {
                return {
                  label: `${degreeShortForm} - ${streamName}`,
                  indices: {
                    degreeIndex,
                    streamIndex,
                    field: 'stream',
                    degreeId,
                    streamId,
                    type,
                  },
                }
              }
            }
          )
        } else {
          return {
            label: `${degreeShortForm}`,
            indices: {
              degreeIndex,
              field: 'degree',
              degreeId,
              type,
            },
          }
        }
      }
    )
  }

  return [] // If 'data' is not an array, return an empty array
}
